<div class="bottom-sheet-closebottom-container">
  <div a11y_Button class="bottom-sheet-closebottom-wrapper" (click)="closeModal()">
    <div class="inline-icon" inlineSVG="shop-icons.svg#ya-close"></div>
  </div>
</div>